import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OrdersRow } from "./orders-row";
import { OrdersOrderCard } from "./orders-order-card";

const HEAD = [
  { id: "order", label: "ORDER ID", align: "left", width: "14%" },
  { id: "customer", label: "CUSTOMER", align: "left", width: "16%" },
  { id: "product", label: "PRODUCT", align: "left", width: "28%" },
  { id: "qty", label: "QUANTITY", align: "left", width: "10%" },
  { id: "price", label: "PRICE", align: "left", width: "12%" },
  { id: "status", label: "STATUS", align: "center", width: "14%" },
  { id: "actions", label: "ACTIONS", align: "center", width: "6%" },
];

function OrdersEmptyState() {
  return (
    <p className="my-0 py-12 text-center text-[14px] font-medium text-[#9CA3AF]">
      No orders match your filters.
    </p>
  );
}

export function OrdersTable({ rows, onViewDetails }) {
  if (!rows.length) {
    return <OrdersEmptyState />;
  }

  return (
    <>
      {/* Mobile: 2-column product grid */}
      <div className="grid grid-cols-2 gap-3 sm:gap-4 md:hidden">
        {rows.map((order) => (
          <OrdersOrderCard
            key={order.id}
            order={order}
            onViewDetails={onViewDetails}
          />
        ))}
      </div>

      {/* Desktop: full table */}
      <TableContainer className="hidden md:block">
        <Table sx={{ tableLayout: "fixed", minWidth: 720 }}>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "#F8F8F8",
                "& th": {
                  border: "none",
                  py: 2,
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  color: "#9CA3AF",
                },
              }}
            >
              {HEAD.map((col) => (
                <TableCell
                  key={col.id}
                  align={col.align ?? "left"}
                  sx={{ width: col.width }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((order) => (
              <OrdersRow
                key={order.id}
                order={order}
                onViewDetails={onViewDetails}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
